package io.github.dautovicharis.charts.app.ui.composable

import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.unit.Dp

internal val LocalChartDemoMaxWidth = staticCompositionLocalOf { Dp.Infinity }
